import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import Swiper, { Navigation, Autoplay, EffectFade } from 'swiper';
import { lock, unlock } from 'tua-body-scroll-lock'
import 'swiper/css';
import 'swiper/css/navigation';
import anime from 'animejs/lib/anime.es.js';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

Swiper.use([Navigation, EffectFade, Autoplay]);

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    animationSelector: '[class*="page-transition-"]',
    plugins: [new SwupPreloadPlugin()]
});

let pageChangingEvent = new Event("pageChanging");
let pageChangedEvent = new Event("pageChanged");
let scrollPositionEvent = new Event("scrollPosition");

// vh bug ios safari
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

Alpine.data('imageSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay, Navigation],
            direction: 'vertical',
            autoHeight: true,
            autoplay: {
                delay: 3500,
            },
            speed: 3500,
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".slider-button-next",
                prevEl: ".slider-button-prev",
            },
            on: {
                init: function () {
                    const numberOfSlides = this.slides.length - 2;
                    if(numberOfSlides <= 1){
                        this.disable();
                    }
                }
            }
        });
    }
}));

// function animateSVGStroke(svgElement, offset, duration) {

//     if (!offset) {
//         offset = 0;
//     }

//     if (!duration) {
//         duration = 500;
//     }

//     let tl = anime.timeline({
//         easing: 'linear',
//         duration: duration,
//         // direction: 'alternate',
//         loop: false
//     });

//     tl
//         // .add({
//         //     targets: svgElement.querySelector('path'),
//         //     strokeDashoffset: [anime.setDashoffset, offset],
//         //     // delay: function (el, i) { return i * 250 }
//         // })
//         .add({
//             targets: svgElement.querySelector('path'),
//             fill: '#383D42',
//             duration: 500,
//         }, 1400);

//     tl.begin;

// }

swup.on('pageLoaded', function () {
  window.dispatchEvent(new Event('resize'));
});

swup.on('animationOutStart', function () {
    console.log('changing');
    document.dispatchEvent(pageChangingEvent);
});

swup.on('contentReplaced', function () {
    console.log('done');
    window.scrollTo(0, 0);
    document.dispatchEvent(pageChangingEvent);
});

Alpine.data('global', () => ({
    isPageReady: false,
    isNavOpen : false,
    isMobileNavOpen : false,
    lightsOff: false,
    pageChanging: false,
    scrollDirection : 'down',
    scrollTop : true,
    scrollPast : true,

    init() {
        setTimeout(() => this.isPageReady = true, 500);
    },

    slideUp() {
        console.log('sliding up');
        // lock(document.body, { useGlobalLockState: true });
        document.body.classList.add('animation-in-progress-reverse');
        window.setTimeout(() => {
            document.body.classList.remove('animation-in-progress-reverse');
            document.body.classList.add('loader-animating');
        }, 2000);
    }
}));

// window.animateSVGStroke = animateSVGStroke;
Alpine.data('loader', () => ({
    init() {
        if (!sessionStorage.getItem("existingUser")) {
            sessionStorage.setItem("existingUser", true);
            document.body.classList.add('loader-animating');
            this.homeLoader();
            window.addEventListener('resize', this.homeLoader);
        }
    },

    slideAway() {
        document.body.classList.add('animation-in-progress');
        window.setTimeout(() => {
            document.body.classList.remove('animation-in-progress');
            document.body.classList.remove('loader-animating');
        }, 2000);
    },

    homeLoader(){
        const homeLoaderPath = document.getElementById('loader-path');
        if(homeLoaderPath && window.screen.width >= 1024){
            let offsetHeight = calcHomeTextOffset();
            const svgText = document.getElementById('loader-text');
            svgText.style.top = offsetHeight + 'px';
        }
    }
}));

function calcHomeTextOffset(){
    const homeLoaderPath = document.getElementById('loader-path');
    // if(homeLoaderPath){
        let pathOffsetHeight = homeLoaderPath.getBoundingClientRect().top;
        let homeLoaderPathHeight = homeLoaderPath.getBoundingClientRect().height;
        let heightPercent = homeLoaderPathHeight * 0.355;
        return pathOffsetHeight + heightPercent - 40;
    // }
}

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();
